import { Component, StrictMode, type ErrorInfo, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/app.css";
import "./styles/header.css";

class ErrorBoundary extends Component<{ children: ReactNode }, { error?: Error }> {
  state: { error?: Error } = {};
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error("FocalFolio fatal UI error", error, info); }
  render() {
    if (this.state.error) return <main className="fatal-error"><div className="brand-large">F<span>●</span></div><h1>FocalFolio could not open the workspace.</h1><p>{this.state.error.message}</p><button type="button" onClick={() => location.reload()}>Reload application</button><small>Original files have not been modified by this UI failure.</small></main>;
    return this.props.children;
  }
}

createRoot(document.getElementById("root")!).render(<StrictMode><ErrorBoundary><App /></ErrorBoundary></StrictMode>);
